import { AsyncButton, Input, Label, showErrorToast, showSuccessToast } from '@bpinternal/ui-kit-next'
import _ from 'lodash'
import { useState } from 'react'
import { ProfilePictureField } from '~/components'
import { Avatar } from '~/elements'
import type { User } from '~/features/users/types'
import { useUpdateUserProfile } from '~/hooks'
import { AccountDangerZone } from './AccountDangerZone'

type Props = {
  user: User
  workspaceId: string
}

export const UserProfileSettings = ({ user, workspaceId }: Props) => {
  const [profile, setProfile] = useState(_.pick(user, 'displayName', 'profilePicture'))

  const { mutate: updateProfile, isPending } = useUpdateUserProfile({
    onSuccess: () => {
      showSuccessToast('Profile updated')
    },
    onError: () => {
      showErrorToast('Error updating profile')
    },
  })

  return (
    <>
      <div className="flex flex-col gap-3 pb-4">
        <ProfilePictureField
          pictureUrl={profile.profilePicture}
          onChange={(pictureUrl) => {
            setProfile({ ...profile, profilePicture: pictureUrl })
          }}
        >
          <Avatar name={user.email} pictureUrl={profile.profilePicture} className="h-16 w-16" />
        </ProfilePictureField>
        <div className="flex flex-col">
          <Label className="text-sm text-gray-10">E-mail</Label>
          <p className="text-sm hover:cursor-not-allowed">{user.email}</p>
        </div>
        <div>
          <Label htmlFor="full-name" className="text-sm text-gray-10">
            Full Name
          </Label>
          <Input
            id="full-name"
            value={profile.displayName ?? ''}
            onChange={(e) => {
              setProfile({ ...profile, displayName: e.target.value })
            }}
            placeholder="John Doe"
          />
        </div>
        <div className="flex justify-end">
          <AsyncButton
            loading={isPending}
            onClick={() => {
              if ((profile.displayName?.length ?? 0) > 100) {
                return showErrorToast('Invalid Name')
              }
              void updateProfile(profile)
            }}
          >
            Update Profile
          </AsyncButton>
        </div>
      </div>
      <AccountDangerZone workspaceId={workspaceId} />
    </>
  )
}
